import CardActions from '@mui/material/CardActions';
import { Item } from 'functions/src/types/firestore/Game/Collection/Item';
import { ItemCard2, ItemCard2Props } from './ItemCard2';
import { ItemCardButtons } from './item-card/buttons/ItemCardButtons';
import { RentalChips } from './item-card/rental-chips/RentalChips';
import { useAuth } from 'src/contexts/AuthContext';
import { ChipViewCollection } from './ChipViewCollection';
import { useState, memo } from 'react';
import { toKebabCase } from 'src/util/string';
import { useServerTime } from 'src/contexts/useServerTime';
import { useMobile } from 'src/contexts/useMobile';
import { useActiveFulfillment } from 'src/hooks/item/useActiveFulfillment';

// import { useAuth } from 'src/contexts/AuthContext';
export type ItemCardPricedProps = Pick<
  Item<Date>,
  | 'lowestAsk'
  | 'contract'
  | 'priceHourly'
  | 'royaltyRental'
  | 'hoursMax'
  | 'rentable'
  | 'whitelistUserIds'
  | 'hasRentOffer'
  | 'collectionId'
  | 'rentCompetitions'
  | 'fulfillmentsRecent'
> &
  ItemCard2Props & {
    showViewCollection?: boolean;
  };

export const ItemCardPriced = memo(function ItemCardPricedUnmemoized(
  props: ItemCardPricedProps,
) {
  const {
    id,
    lowestAsk,
    rentable,
    priceHourly,
    royaltyRental,
    hoursMax,
    whitelistUserIds,
    collectionId,
    hasRentOffer = false,
    contract,
    showViewCollection = true,
    gameTitle,
    fulfillmentsRecent,
    rentCompetitions,
    root,
  } = props;
  //const { checkItemOwnership } = useAuth();
  //const isOwner = checkItemOwnership(contract?.address, contract?.itemId);
  const { user, userData } = useAuth();
  const { now } = useServerTime();
  const isMobile = useMobile();
  // TODO: revert to checkItemOwnership
  const userItems = userData?.itemIdsOwned;
  const isOwner = userItems?.some((item) => {
    const [_chainId, contractAddress, itemId] = item.split('-');
    return itemId === id && contractAddress === contract.address;
  });
  const showAsWhitelisted =
    !!whitelistUserIds &&
    !whitelistUserIds.includes(user?.uid || '') &&
    !isOwner;

  const [viewCollectionTag, setViewCollectionTag] = useState(false);
  // const [collectionAbsoluteUrl, setCollectionAbsoluteUrl] = useState('');
  const collectionUrl = `/game/${toKebabCase(gameTitle)}/${
    gameTitle === 'Undead Blocks' ? 'weapons' : 'items'
  }?filters=collection%3A${collectionId}`;

  const fulfillmentActive = useActiveFulfillment({
    fulfillmentsRecent,
  });
  const rentedUntil = fulfillmentActive?.expiresAt;
  const rentedFrom = fulfillmentActive?.createdAt;

  const isItemRented =
    !!rentedUntil &&
    !!rentedFrom &&
    rentedUntil.getTime() > now() &&
    rentedFrom?.getTime() < now();

  return (
    <ItemCard2
      {...props}
      onMouseEnter={() => {
        isMobile ? undefined : setViewCollectionTag(true);
      }}
      onMouseLeave={() => {
        isMobile ? undefined : setViewCollectionTag(false);
      }}
    >
      <>
        {(!!hoursMax || isItemRented) && (
          <RentalChips
            hoursMax={hoursMax || 14}
            royalty={royaltyRental || 0}
            rentedUntil={rentedUntil}
            showAsWhitelisted={showAsWhitelisted}
            forTournaments={rentCompetitions}
          />
        )}
        {((!!viewCollectionTag && !!showViewCollection) || isMobile) && (
          <ChipViewCollection url={collectionUrl} />
        )}

        <CardActions>
          <ItemCardButtons
            lowestAsk={lowestAsk || undefined}
            contractAddress={contract.address}
            chainId={contract.chainId}
            priceHourly={priceHourly || undefined}
            itemId={id}
            rentable={rentable}
            rentedUntil={rentedUntil}
            isOwner={isOwner}
            isWhitelisted={!!whitelistUserIds}
            showAsWhitelisted={showAsWhitelisted}
            hasRentOffer={hasRentOffer}
            contractType={contract.type}
            isItemRented={isItemRented}
          />
        </CardActions>
      </>
    </ItemCard2>
  );
});
